import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M5 1v22h14V1H5zm12 18H7V5h10v14z"
}), 'SmartphoneSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/SmartphoneSharp.js
// module id = 6286
// module chunks = 2